import React from 'react';
import {Table, Button} from 'semantic-ui-react';

const TableListDescription = ({list, handleAction}) => {
  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>#</Table.HeaderCell>
          <Table.HeaderCell>TIPO</Table.HeaderCell>
          <Table.HeaderCell>DESCRIPCIÓN</Table.HeaderCell>
          <Table.HeaderCell>ACCIONES</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {list.map((item, index) => (
          <Table.Row key={item.id}>
            <Table.Cell>{index + 1}</Table.Cell>
            <Table.Cell>{item.value}</Table.Cell>
            <Table.Cell>{item.description}</Table.Cell>
            <Table.Cell collapsing >
              <Button onClick={() => handleAction('UPDATE', item)} size="tiny" color="yellow">EDITAR</Button>
              <Button onClick={() => handleAction('DELETE', item)} size="tiny" color="red">ELIMINAR</Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default TableListDescription;
